<template lang="pug">
  v-container(fluid style="height:100%").adv-search.d-flex-flex-column
    Breadcrumbs()
    h1.black--text.text-center Open Data
    .d-flex.justify-center
      v-btn(text color="primary" :to="{name: 'results'}").mb-2 Switch to Simple Search
    v-progress-linear(:indeterminate="loading" :active="loading")
    v-row
      v-col(cols=6).pb-0
        v-card(outlined).pa-4
          v-form
            v-card.d-flex.pa-4
              v-select(
                v-model="searchBy"
                outlined
                hide-details
                :items="searchByOptions"
                label="Search by"
                style="max-width:160px"
              )
              v-text-field.ml-4(
                clearable
                outlined
                placeholder="Search term"
                prepend-inner-icon="search"
                v-model="term"
                hide-details
                @keydown.enter='search'
              )
            v-card.pa-4.mt-4.d-flex
              v-select(
                v-model="orderBy"
                outlined
                hide-details
                :items="orderByOptions"
                label="Order By"
              )
              v-select.ml-4(
                v-model="orderByAsc"
                outlined
                hide-details
                :items="ascDescOptions"
                style="max-width:160px"
              )
            v-card.pa-4.mt-4(v-for="(filter, index) in filters" :key="filter.id").d-flex.align-center
              v-select(
                v-model="filter.filterBy"
                outlined
                hide-details
                :items="filterByOptions"
                label="Filter by"
                @input="filter.input=''"
              )
              v-select.ml-4(
                v-model="filter.altType"
                outlined
                hide-details
                :items="itemsFor(filter.filterBy)"
              )
              .ml-4(v-if="filter.filterBy == 'publishDate' || filter.filterBy == 's3_details.LastModified'")
                DatePicker(
                  v-model="filter.input"
                )
              v-text-field.ml-4(
                v-else
                clearable
                outlined
                v-model="filter.input"
                hide-details
              )
              v-btn(fab small color="red" @click="filters.splice(index, 1)").ml-4
                v-icon(large color="white") close
            .d-flex
              v-btn.mt-4(text color='primary' @click="generateFilter") + Add Filter
              v-spacer
              v-tooltip(bottom dark)
                template(v-slot:activator="{on}")
                  v-checkbox(v-model="showProtected" label="Show Internal Use Datasets")
                span Internal use datasets are designed to support County backend processes, may include personal information about County employees and, accordingly, are not made publicly available.
            .d-flex.mt-4
              v-spacer
              v-btn(large color="primary" @click="search" :loading="loading") Search
      v-col(cols=6).pb-0
        v-card(outlined).pa-2.d-flex.flex-column
          Datacard(
            v-for="(result, index) in data" :key="result.id"
            :title="result.title"
            :description="result.description"
            :number-of-records="result.number_of_records"
            :s3-details="result.s3_details"
            :url="result.data_source"
            :ext-url="result.external_url"
            :dataset-id="result.id"
            :collection-id="result.collection ? result.collection.id : null"
            :collection-title="result.collection ? result.collection.title : null"
            :to="{name:'dataset',params:{id:result.id}}"
            rows="2"
            show-nav
            dense
            outlined
            showCollection
            hoverDetails
            :isProtected="result.visibility=='protected'"
          ).ma-2
          v-spacer
          .d-flex.justify-space-between.align-center.ma-2
            v-btn.flex-shrink-1(width=150 color="primary" :disabled="atMinPage" @click="prevPage")
              v-icon(:left="$vuetify.breakpoint.smAndUp") mdi-arrow-left
              span.d-none.d-sm-inline Previous
            p.text-center.my-auto.mx-4.flex-shrink-0 Page {{page+1}} of {{maxPage+1}}
            v-btn.flex-shrink-1(width=150 color="primary" :disabled="atMaxPage" @click="nextPage")
              span.d-none.d-sm-inline Next
              v-icon(:right="$vuetify.breakpoint.smAndUp") mdi-arrow-right
</template>

<script>
import Datacard from '@/components/Datacard.vue'
import DatePicker from '@/components/DatePicker.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
  components: {
    Datacard,
    DatePicker,
    Breadcrumbs
  },
  data: () => ({
    searchByOptions: [
      { text: "Title", value: 'title' },
      { text: "Description", value: "description" },
      { text: "Tags", value: "tags" }
    ],
    orderByOptions: [
      { text: "Relevance", value: '_score' },
      { text: 'Last Update', value: 's3_details.LastModified' },
      { text: 'Publish Date', value: 'publish_date' },
      { text: 'Title', value: 'title.raw' }
    ],
    ascDescOptions: [
      { text: "Ascending", value: "asc" },
      { text: "Descending", value: "desc" }
    ],
    filterByOptions: [
      //{ text: 'Department', value: 'department' },
      { text: 'Publish Date', value: 'publishDate' },
      { text: 'Last Update', value: 's3_details.LastModified' }
      //{ text: 'Number of Records', value: 'numRecords' }
    ],
    includeDiscludeOptions: [
      { text: 'Include', value: false },
      { text: 'Disclude', value: true }
    ],
    beforeAfterOptions: [
      { text: 'Before', value: false },
      { text: 'After', value: true }
    ],
    ltGtOptions: [
      { text: 'Less Than', value: false },
      { text: 'Greater Than', value: true }
    ],
    filterIdCounter: 0
  }),
  computed: {
    loading () { return this.$store.state.loading },
    term: {
      get() { return this.$store.state.term },
      set(value) { this.$store.commit('set', { term: value }) }
    },
    orderBy: {
      get() { return this.$store.state.orderBy },
      set(value) { this.$store.commit('set', { orderBy: value }) }
    },
    orderByAsc: {
      get() { return this.$store.state.orderByAsc },
      set(value) { this.$store.commit('set', { orderByAsc: value }) }
    },
    showProtected: {
      get() { return this.$store.state.showProtected },
      set(value) { this.$store.commit('set', { showProtected: value }) }
    },
    searchBy: {
      get() { return this.$store.state.adv.searchBy },
      set(value) { this.$store.commit('set', { adv: { searchBy: value, filters: this.filters }})}
    },
    filters: {
      get() { return this.$store.state.adv.filters },
      set(value) { this.$store.commit('set', { adv: { searchBy: this.searchBy, filters: value }})}
    },
    data () { return this.$store.state.data },
    page () { return this.$store.state.page },
    pageSize: {
      get() { return this.$store.state.pageSize },
      set(value) { this.$store.commit('set', { pageSize: value }) }
    },
    resultCount () { return this.$store.state.resultCount },
    atMinPage () { return this.$store.getters.atMinPage },
    atMaxPage () { return this.$store.getters.atMaxPage },
    maxPage () { return this.$store.getters.maxPage }
  },
  methods: {
    itemsFor(filterBy) {
      if(filterBy == 'publishDate' || filterBy == 's3_details.LastModified')
        return this.beforeAfterOptions
      else
        return this.ltGtOptions
    },
    search () {
      if(!this.term && this.orderBy == "_score")
        this.orderBy = "title.raw"
      return this.$store.commit('search')
    },
    nextPage () { return this.$store.commit('nextPage') },
    prevPage () { return this.$store.commit('prevPage') },
    generateFilter () {
      this.filterIdCounter += 1
      this.filters.push({
        filterBy: 'publishDate',
        altType: false,
        input: '',
        id: this.filterIdCounter
      })
    }
  },
  created() {
    this.$store.commit('initAdv')
    this.filterIdCounter = this.filters.reduce((max, filter) => {
      return max > filter.id ? max : filter.id
    }, 0)
  }
}
</script>